import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomRouteListener = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.Hosting.router = {
      navigate,
    };
    window.Hosting.routes = {
      hosting: '/',
      sites: '/sites',
      email: '/email',
      appsDeployRoot: '/apps-deploy',
      appsDeployOverview: '/apps-deploy/overview',
      appsDeployConfigure: '/apps-deploy/configure',
      appsDeployActivity: '/apps-deploy/activity',
      aiSites: '/ai-sites',
      aiStore: '/ai-store',
    };
  }, [navigate]);

  return <>{children}</>;
};

export default CustomRouteListener;
